export const sustainability = {
  hero: {
    title: 'Sustainability Commitment',
    subtitle: 'Clean Label, Green Cycle',
    description: 'ShanDouDou believes that true health is not just nourishment for the body, but also the brand\'s responsibility to the planet. From raw material procurement to packaging design, we adhere to full-chain sustainable practices.',
  },
  commitments: [
    {
      title: 'Clean Label Promise',
      description: 'Rejecting excessive chemical additives. Every ingredient on our product labels is a natural ingredient you can read and look up. No complex chemical names — only gifts from nature.',
      stats: [
        { value: '0', label: 'Artificial Colors' },
        { value: '0', label: 'Artificial Flavors' },
        { value: '0', label: 'Preservatives' },
        { value: '100%', label: 'Traceable' },
      ],
    },
    {
      title: 'Green Supply Chain',
      description: 'Sourcing from 36 premium global origins with long-term partnerships with organic farms. Prioritizing suppliers meeting fair trade standards to ensure every gram comes from responsible cultivation and harvesting.',
      stats: [
        { value: '36', label: 'Global Origins' },
        { value: '100%', label: 'Raw Material Testing' },
        { value: '50%+', label: 'Organic Partners' },
        { value: '0', label: 'GMO' },
      ],
    },
    {
      title: 'Circular Packaging Design',
      description: 'Using FSC-certified paper, biodegradable bio-based materials, and recyclable aluminum foil packaging. Between product display aesthetics and environmental responsibility, we never choose — we demand both.',
      stats: [
        { value: '100%', label: 'FSC Paper' },
        { value: '80%', label: 'Degradable Mat.' },
        { value: '0', label: 'Single-Use Plastic' },
        { value: '50%', label: 'Carbon Reduction' },
      ],
    },
    {
      title: 'Carbon Neutral Goal',
      description: 'Through optimized production processes, green power procurement, and forestry carbon sink projects, ShanDouDou commits to full-chain carbon neutrality by 2030. We are measuring every step\'s carbon footprint with data.',
      stats: [
        { value: '30%', label: 'Current Reduction' },
        { value: '2030', label: 'Carbon Neutral Year' },
        { value: '100%', label: 'Green Power' },
        { value: '∞', label: 'Continuous' },
      ],
    },
  ],
  certifications: {
    title: 'Certifications',
    subtitle: 'ShanDouDou products and processes have earned multiple domestic and international authoritative certifications',
    list: [
      { name: 'ISO 22000', desc: 'Food Safety Management System' },
      { name: 'HACCP', desc: 'Hazard Analysis Critical Control Points' },
      { name: 'Organic Cert.', desc: 'China Organic Product Certification' },
      { name: 'FSC', desc: 'Forest Stewardship Council Certification' },
      { name: 'Clean Label', desc: 'International Clean Label Alliance' },
      { name: 'Carbon Footprint', desc: 'Product Life Cycle Carbon Footprint Cert.' },
    ],
  },
  report: {
    title: 'Annual Sustainability Report',
    description: 'We publish the "ShanDouDou Sustainability Report" annually, transparently disclosing the brand\'s progress and goals in environmental protection, social responsibility, and corporate governance.',
    cta: 'Download Latest Report',
  },
};